__turbopack_context__.v({
  "blok-big-title": "issuu-module___3Optq__blok-big-title",
  "blok-subtitle": "issuu-module___3Optq__blok-subtitle",
  "blok-title": "issuu-module___3Optq__blok-title",
  "close-button": "issuu-module___3Optq__close-button",
  "fadeIn": "issuu-module___3Optq__fadeIn",
  "hacky-div": "issuu-module___3Optq__hacky-div",
  "heading": "issuu-module___3Optq__heading",
  "issuuembed": "issuu-module___3Optq__issuuembed",
  "modal": "issuu-module___3Optq__modal",
  "trigger__icon": "issuu-module___3Optq__trigger__icon",
  "trigger__label": "issuu-module___3Optq__trigger__label",
  "wrapper": "issuu-module___3Optq__wrapper",
});
